




































import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import LiveCountIndicator from '@app/mobile/components/LiveCountIndicator.vue';
import { BottomBarItemId } from '@src/app/types';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { NavigationDataStore } from '@store/modules/navigation';
import {
    NavigationContext,
    Site,
} from '@superbet-group/web.types';
import store from '@store/index';
import { getterFromPath } from '@modules/layout/utils/storeGetter';
import { currentSite } from '@src/app/utils/domainHelpers';
import { getShellConfig } from '@src/config/shell/config';
import { RouteName } from '@src/app/router/constants/RouteName';
import { napoleonHubNavigationItems } from '../helpers/navigation';
import { showFeatureTestingDisclaimer } from '@src/app/utils/featureTesting';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    setup() {
        const { route: currentRoute } = useVueRouter();
        const navigationModule = useVuexStore<NavigationDataStore>('navigation');

        function track(barItemId: BottomBarItemId) {
            AnalyticsSDK.getInstance().log(
                'Bottom_Menu_Interaction',
                { eventLabel: barItemId },
            );
            if (barItemId === BottomBarItemId.MyTickets) {
                AnalyticsSDK.getInstance().log('Tab_Tickets');
            }
        }

        // eslint-disable-next-line sonarjs/cognitive-complexity
        const barItems = computed(() => {
            if (getShellConfig().remoteConfig.areSitesSplitByLicence
                && [
                    RouteName.GrowthMarketing.LandingIntro,
                    RouteName.App.Wiki,
                ].includes(currentRoute.value.name!)
                && currentSite === Site.NapoleonGames
            ) {
                return napoleonHubNavigationItems;
            }
            const currentTopLevelNavigation = navigationModule.getter('currentTopLevelNavigation').value!;
            if (!currentTopLevelNavigation) {
                return [];
            }
            let currentNavigationItems;
            if (currentRoute.value.meta?.navigationContext === NavigationContext.Neutral) {
                currentNavigationItems = [{
                    isSelected: false,
                    dynamic: true,
                    name: currentTopLevelNavigation.contextSwitcher.label,
                    destination: currentTopLevelNavigation.contextSwitcher.destination,
                    id: currentTopLevelNavigation.contextSwitcher.label,
                    icon: currentTopLevelNavigation.contextSwitcher.icon!.replace('sds-icon-', ''),
                }];
            } else {
                const items = currentTopLevelNavigation?.mobileItems ?? [];
                currentNavigationItems = [...items]
                    .filter((item) => {
                        if (item.hideOnSites && getShellConfig().remoteConfig.areSitesSplitByLicence) {
                            return !item.hideOnSites.includes(currentSite);
                        }
                        return true;
                    })
                    .sort((a, b) => {
                        return a.order - b.order;
                    })
                    .map((item) => {
                        return {
                            isSelected: item.isActive ? item.isActive(currentRoute.value) : false,
                            dynamic: true,
                            name: item.label,
                            destination: item.destination,
                            id: item.label,
                            icon: item.icon!.replace('sds-icon-', ''),
                            badge: getterFromPath(item.badgeStoreGetter, store),
                            itemClasses: item.itemClasses,
                        };
                    });
            }
            const topLevelNavigations = navigationModule.getter('topLevelNavigations').value;
            const otherNavigations = Object.keys(topLevelNavigations)
                .filter((key) => key !== navigationModule.getter('currentNavigationContext').value)
                .map((key) => {
                    const topLevelNav = topLevelNavigations[key as NavigationContext]!.contextSwitcher;
                    if (!topLevelNav) {
                        return null;
                    }
                    return {
                        isSelected: false,
                        dynamic: true,
                        name: topLevelNav.label,
                        destination: topLevelNav.destination,
                        id: topLevelNav.label,
                        icon: (topLevelNav.mobileIcon ?? topLevelNav.icon!)!.replace('sds-icon-', ''),
                        itemClasses: topLevelNav.itemClasses,
                    };
                }).filter((item) => item !== null);
            return [
                ...currentNavigationItems,
                ...otherNavigations,
            ];
        });

        return {
            barItems,
            track,
            showDisclaimer: computed(() => showFeatureTestingDisclaimer.showDisclaimer),
        };
    },
    components: {
        LiveCountIndicator,
        SdsIcon,
    },
});
